export default function ScrollProgress({ progress }) {
  return (
    <div
      className="fixed top-0 left-0 h-[2px] z-[60] bg-accent motion-reduce:transition-none"
      style={{ width: `${progress}%`, transition: 'width 80ms linear' }}
      role="progressbar"
      aria-valuenow={Math.round(progress)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Scroll progress"
    />
  );
}
